'use client'

import type { ReactNode } from 'react'

import { useFeatureFlag } from '@moment/app-config-ui'
import { IconArrowOutOfBox } from '@moment/design-system-ui/icon/IconArrowOutOfBox'
import { IconSize } from '@moment/design-system-ui/icon/types'

import { HELD_AWAY_ACCOUNTS } from '@/app/feature-flags'
import Tooltip from '@/components/atomic/tooltip'

export const HELD_AWAY_STATUS_TOOLTIP = 'Held-away manually uploaded'

interface HeldAwayStatusIconProps {
  fallback?: ReactNode
}

export function HeldAwayStatusIcon({
  fallback = null,
}: HeldAwayStatusIconProps) {
  const heldAwayEnabled = useFeatureFlag(HELD_AWAY_ACCOUNTS)
  if (!heldAwayEnabled) {
    return fallback
  }

  return (
    <div className="flex items-center justify-center w-full">
      <Tooltip side="top" simpleText={HELD_AWAY_STATUS_TOOLTIP}>
        <div
          className="flex size-6 items-center justify-center rounded-[5px] border border-border-default bg-surface-secondary"
          data-testid="held-away-status-icon"
        >
          <IconArrowOutOfBox
            size={IconSize.Small}
            className="text-icon-secondary"
          />
        </div>
      </Tooltip>
    </div>
  )
}
